import type { KeyDict } from '@/types'
import { FanRoomScheduleConfigManual } from './FanRoomScheduleConfigManual'
import { FanRoomScheduleConfigTimed } from './FanRoomScheduleConfigTimed'
import { Loader, Result } from 'kiswe-ui'

export class AdminFanRoomScheduleConfigs {
  manual: KeyDict<FanRoomScheduleConfigManual>
  manual_cleanup_delay?: number
  timed: KeyDict<FanRoomScheduleConfigTimed>

  constructor (data: unknown) {
    this.manual = Loader.loadKeyDict<FanRoomScheduleConfigManual>(
      data, 'manual', (item: unknown) => new FanRoomScheduleConfigManual(item)
    )
    this.manual_cleanup_delay = Loader.loadNumber(data, 'manual_cleanup_delay', 3600 * 24)
    this.timed = Loader.loadKeyDict<FanRoomScheduleConfigTimed>(
      data, 'timed', (item: unknown) => new FanRoomScheduleConfigTimed(item)
    )
  }

  static load (data: unknown): Result<AdminFanRoomScheduleConfigs, 'invalid_params'|'unknown'> {
    try {
      return Result.success(new AdminFanRoomScheduleConfigs(data))
    } catch (error) {
      return Result.fromUnknownError('invalid_params', error)
    }
  }
}
